import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { notification } from "antd";
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TobNavBar from "../../../DashBaord/Top_navbar";
// import VendorListDeletePopUp from "./DeletePopUp";
import { useLocation } from "react-router-dom";
import moment from "moment";
import SkeltonList from "../../../../components/SkeltonEffect/list";
import {
  getLoadBalanceData
} from "../../../../controllers/V1/invoice/invoiceControllers";
import { list as dueList} from '../../../../controllers/V1/customerDue/dueController';
import { getRelativeTime } from "../../../../controllers/common";

import * as XLSX from 'xlsx';
function VendorList(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

VendorList.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function BasicTabs() {
  /************************************************************************************* */
  const [isLoading, setIsLoading] =useState(true);
  const location = useLocation();
  const targetRef = useRef(null);
  const [ALLLISTDATA, setListData] = useState([]);

  const [pendingInvoice, setPendingInvoice] = useState([]);
  const [pendingInvoiceCount, setPendingInvoiceCount] = useState(0);
 
  /*********************************************************
   *  This function is use to fetch vendor list
   *********************************************************/
  const getList = async () => {
    try {
      // console.log('batch_id',batch_id);
      setIsLoading(true);
      setListData([]);
      const {state}= location;
      if (state && state?.retailerList?.length > 0) {
          const listData = await Promise.all(
              state.retailerList.map(items => ({
                  // add your transformed object here
                  _id : items?._id,
                  users_oid : items?._id,
                  users_id : items?.users_id,
                  store : items?.store_name || 'N/A',
                  pos_number : items?.pos_number || 'N/A',
                  area : items?.area || 'N/A',
                  sales_person_name : items?.bind_person_name || 'N/A',
                  users_mobile : items?.users_mobile || 'N/A',
                  users_name   : items?.users_name || 'N/A',

                  start_date : state?.start_date,
                  end_date : state?.end_date,
                  start_time : state?.start_time,
                  end_time : state?.end_time,
                  invoice_date : state?.invoice_date,
                  status : "Pending",
                  remarks : ""


              }))
          );
          setListData(listData);
          setPendingInvoice(listData);
          setPendingInvoiceCount(listData?.length || 0); 
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }; //End
 
  /*********************************************************
   *  This function will load when page load and with dependency update
   *********************************************************/
  useEffect(() => {
    getList();
    targetRef.current.scrollIntoView({
      behavior:'smooth',
    });
    document.title = "CRM U-Winn || Export Excel";
  }, []);
  
  const fetchUserDue = async (user_id) => {
    try {
      const option = {
        type : 'single',
        condition : { _id : user_id },
        select : {due_amount : true}
      }
      const res = await dueList(option);
      if(res.status === true){
        return res.result?.due_amount || 0
        // setInvoiceData((pre)=>({
        //   ...pre,
        //   old_balance : due?.due_amount
        // }))
      } else{
        return 0;
        // setInvoiceData((pre)=>({
        //   ...pre,
        //   old_balance : 0
        // }))
      }
    } catch (error) {
      return 0;
    }
  }

  useEffect(()=>{
    if(pendingInvoiceCount > 0){
      generateInvoice(pendingInvoice[pendingInvoiceCount - 1]);
    } else {
      // requestChangeStatus(batch_id);
      handleExportExcel();
    }
  },[pendingInvoiceCount]);

  const handleExportExcel = () => {
    try {
      if(ALLLISTDATA && ALLLISTDATA?.length > 0){
          let modifiedData = ALLLISTDATA.map((items, index) => ({
              "Sl. No"                : index + 1,
              "STORE NAME"            : items?.store,
              "POS NO"                : items?.pos_number,
              "BIND WITH"             : items?.sales_person_name,
              "DURATION"              : ` ${moment(items?.start_date).format("DD-MM-YYYY")} ${moment(`2025-03-03 ${items?.start_time}`).format('HH:mm')} to ${moment(items?.end_date).format("DD-MM-YYYY")} ${moment(`2025-03-03 ${items?.end_time}`).format('HH:mm')}
                                        `,
              "DAILY DRAW SALES"      : items?.lottoTotalSales,
              "DAILY DRAW COMMISSION" : items?.lottoTotalCommission,
              "DAILY DRAW REDEEM"     : items?.lottoPaidAmount,

              "RAFFLE SALES"          : items?.raffleTotalSales,
              "RAFFLE COMMISSION"     : items?.raffleTotalCommission,
              "RAFFLE REDEEM"         : items?.rafflePaidAmount,

              "U-POINTS SALES"        : items?.pointsTotalSales,
              "U-POINTS COMMISSION"   : items?.pointsTotalCommission,
              "U-POINTS REDEEM"       : items?.pointsPaidAmount,
              "REDEEM COMMISSION"     : items?.pointsRedeemCommission,

              "REFERRAL BONUS"        : items?.pointsIncentives,

              "HOURLY SALES"        : items?.hourlyTotalSales,
              "HOURLY COMMISSION"   : items?.hourlyTotalCommission,
              "HOURLY REDEEM"       : items?.hourlyPaidAmount,

              "OLD DUE"               : items?.old_pending_balance || 0,
              "Wi-Fi INCENTIVE"         : items?.wifi_incentive || 0,
              // "TOTAL DUE"             : (items?.total_due + parseFloat(items?.old_pending_balance || 0)),
              "TOTAL DUE"             : items?.sub_total_due || 0,
              // "CREATED AT"            : moment(items?.createdAt).format('YYY-MM-DD HH:mm')
            }));
            // console.log('modifiedData : ', modifiedData);
            const workbook = XLSX.utils.book_new();
            const worksheet1 = XLSX.utils.json_to_sheet(modifiedData);
      
            XLSX.utils.book_append_sheet(workbook, worksheet1, "Due");
            XLSX.writeFile(workbook, `Invoice Summary ${moment().format('YYYY-MM-DD')}.xlsx`);
           
      } else{
        notification.open({
          message: "Oops!",
          description: `No Data Found.`,
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
          duration: 2,
        });
      }
    } catch (error) {
      console.log('error : ', error);
    }
  }

/*********************************************************
 *  This function is use to handle form submit
 *********************************************************/
const generateInvoice = async (data) => {
  try {
    if(!data.users_id){
      alert('Please select user');
    } else{
      setListData((prev) =>
        prev.map((item) =>
          item._id === data._id ? { ...item, status: 'Preparing' } : item
        )
      );

      const startDate = moment(data?.start_date).format('YYYY-MM-DD');
      const endDate = moment(data?.end_date).format('YYYY-MM-DD');

      const startTime = data?.start_time || '21:31:00';
      const endTime = data?.end_time || '21:30:00';

      // const startDate = data?.start_date; 
      // const endDate = data?.end_date;

      const options = {
        condition : {
          $or : [
            {user_id_deb : parseInt(data?.users_id)},
            {user_id_cred : parseInt(data?.users_id)}
          ],
          created_at : { $gte : `${startDate} ${startTime}`, $lte : `${endDate} ${endTime}` }
        }
      }
      const res = await getLoadBalanceData(options);
      if(res?.status === true){

         //Lotto
         let lottoTotalSalesAmount = 0;
         let lottoTotalCommissionAmount = 0;
         let lottoTotalPaidAmount = 0;
         //Raffle

         let raffleTotalSalesAmount = 0;
         let raffleTotalCommissionAmount = 0;
         let raffleTotalPaidAmount = 0;
         //U-Points
         
         let pointsTotalSalesAmount = 0;
         let pointsTotalCommissionAmount = 0;
         let pointsTotalInsensitiveAmount = 0;
         let pointsTotalPaidAmount = 0;
         let pointsRedeemCommission = 0;

         let salesAmount = 0;
         let commissionAmount = 0;
         let paidAmount = 0;
         let insensitiveAmount = 0;
         
         let old_balance = 0;
         let totalDueAmount = 0;
         let subTotalDue = 0;
         let total_debit = 0;

        let status = 'Completed';
        let remarks = '';

        old_balance = await fetchUserDue(data?.users_oid);

        if(res?.result?.length > 0){

          const result = res?.result.reduce(
            (acc, item) => {
              //Lotto
                if (item.narration === "Order") {
                    acc.orderSum += item.upoints || 0;
                } else if (item.narration === "Order Cancalled") {
                    acc.cancelledSum += item.upoints || 0;
                } else if(item.narration === 'Commission'){
                    acc.commissionSum += parseFloat(item.upoints) || 0;
                } else if(item.narration === 'Commission Reverted'){
                    acc.commissionRevertedSum += parseFloat(item.upoints) || 0;
                } else if(item.narration === 'Redeem Prize' && item?.user_type !== 'Users'){
                  acc.paidSum += parseFloat(item.upoints) || 0;
                }

                //Raffle
                else if(item.narration === "Raffle Order"){
                  acc.raffleOrdSum += item.upoints || 0;
                } else if(item.narration === "Raffle Order Cancalled"){
                  acc.raffleCancelSum += item.upoints || 0;
                } else if(item.narration === "Raffle Commission"){
                  acc.raffleCommissionSum += item.upoints || 0;
                } else if(item.narration === "Raffle Commission Reverted"){
                  acc.raffleCommissionReverse += item.upoints || 0;
                } else if(item.narration === "Raffle Cash Prize Redeem"){
                  acc.rafflePaidSum += item.upoints || 0;
                }

                //U-Points
                else if((item.narration === "Recharge" || item.narration === "Recharge Coupon") && item.record_type === 'Debit'){
                  acc.pointsOrdSum += item.upoints || 0;
                } else if(item.narration === "Recharge Coupon Cancelled"){
                  acc.pointsCancelSum += item.upoints || 0;
                } else if(item.narration === "Recharge Commission"){
                  acc.pointsCommissionSum += item.upoints || 0;
                } else if(item.narration === "Referrel Commission"){
                  acc.pointsInsensitive += item.upoints || 0;
                } else if(item.narration === "Recharge Commission Reverted"){
                  acc.pointsCommissionReverse += item.upoints || 0;
                } else if(item.narration === "Cash Prize Redeem" || (item.narration === 'Redeem Prize' && item?.user_type === 'Users')){
                  acc.pointsPaidSum += item.upoints || 0;
                } else if(item.narration === "Redeem Prize Commission"){
                  acc.pointsRedeemCommission += item.upoints || 0;
                }
    
                return acc;
            },
            { 
              orderSum: 0, cancelledSum: 0, commissionSum : 0, commissionRevertedSum:0, paidSum : 0,
              raffleOrdSum : 0, raffleCancelSum : 0, raffleCommissionSum : 0, raffleCommissionReverse : 0, rafflePaidSum : 0, 
              pointsOrdSum : 0, pointsCancelSum : 0, pointsCommissionSum : 0, pointsCommissionReverse : 0, pointsPaidSum : 0, pointsInsensitive : 0,
              pointsRedeemCommission : 0
            }
          );

          const totalSales = parseFloat(result.orderSum) - parseFloat(result.cancelledSum);
          const totalCommission = parseFloat(result.commissionSum) - parseFloat(result.commissionRevertedSum);
          //Lotto
          lottoTotalSalesAmount = totalSales;
          lottoTotalCommissionAmount = totalCommission;
          lottoTotalPaidAmount = result?.paidSum;
          //Raffle
          const totalRaffleSales = parseFloat(result.raffleOrdSum) - parseFloat(result.raffleCancelSum);
          const totalRaffleCommission = parseFloat(result.raffleCommissionSum) - parseFloat(result.raffleCommissionReverse);

          raffleTotalSalesAmount = totalRaffleSales;
          raffleTotalCommissionAmount = totalRaffleCommission;
          raffleTotalPaidAmount = result?.rafflePaidSum;
          //U-Points
          const totalPointsSales = parseFloat(result.pointsOrdSum) - parseFloat(result.pointsCancelSum);
          const totalPointsCommission = parseFloat(result.pointsCommissionSum) - parseFloat(result.pointsCommissionReverse);

          pointsTotalSalesAmount = totalPointsSales;
          pointsTotalCommissionAmount = totalPointsCommission;
          pointsTotalInsensitiveAmount = result.pointsInsensitive || 0;
          pointsTotalPaidAmount = result?.pointsPaidSum || 0;
          pointsRedeemCommission = result?.pointsRedeemCommission || 0;

          if(parseFloat(lottoTotalSalesAmount) > 0) salesAmount += parseFloat(lottoTotalSalesAmount);
          if(parseFloat(lottoTotalCommissionAmount) > 0) commissionAmount += parseFloat(lottoTotalCommissionAmount);
          if(parseFloat(lottoTotalPaidAmount) > 0) paidAmount += parseFloat(lottoTotalPaidAmount);


          if(parseFloat(raffleTotalSalesAmount) > 0) salesAmount += parseFloat(raffleTotalSalesAmount);
          if(parseFloat(raffleTotalCommissionAmount) > 0) commissionAmount += parseFloat(raffleTotalCommissionAmount);
          if(parseFloat(raffleTotalPaidAmount) > 0) paidAmount += parseFloat(raffleTotalPaidAmount);

          if(parseFloat(pointsTotalSalesAmount) > 0) salesAmount += parseFloat(pointsTotalSalesAmount);
          if(parseFloat(pointsTotalCommissionAmount) > 0) commissionAmount += parseFloat(pointsTotalCommissionAmount);
          if(parseFloat(pointsTotalInsensitiveAmount) > 0) insensitiveAmount += parseFloat(pointsTotalInsensitiveAmount);
          if(parseFloat(pointsTotalPaidAmount) > 0) paidAmount += parseFloat(pointsTotalPaidAmount);
          
          
          total_debit = commissionAmount + paidAmount;
          
          totalDueAmount += parseFloat(salesAmount) 
          totalDueAmount -= parseFloat(total_debit) 
          totalDueAmount -= parseFloat(insensitiveAmount);
          totalDueAmount -= parseFloat(pointsRedeemCommission);
          
          
          subTotalDue += parseFloat(totalDueAmount);

          // old_balance = await fetchUserDue(data?.users_oid);
          if(old_balance > 0){
            subTotalDue += parseFloat(old_balance);
          }

        } else if(old_balance > 0){
            subTotalDue += parseFloat(old_balance);
        } else {
          status = 'Fail';
          remarks = 'No sales found'
        }

        // const params = {
        //   id : data._id,

        //   lottoTotalSales : lottoTotalSalesAmount,
        //   lottoTotalCommission : lottoTotalCommissionAmount,
        //   lottoPaidAmount : lottoTotalPaidAmount,


        //   raffleTotalSales : raffleTotalSalesAmount,
        //   raffleTotalCommission : raffleTotalCommissionAmount,
        //   rafflePaidAmount : raffleTotalPaidAmount,

        //   pointsTotalSales : pointsTotalSalesAmount, 
        //   pointsTotalCommission : pointsTotalCommissionAmount,
        //   pointsIncentives : pointsTotalInsensitiveAmount,
        //   pointsPaidAmount : pointsTotalPaidAmount, 
        //   pointsRedeemCommission   : pointsRedeemCommission,
          
        //   total_incentives : pointsTotalInsensitiveAmount,
        //   total_sales : salesAmount,
        //   total_commission : commissionAmount,
        //   total_paid : paidAmount,
        //   total_due : totalDueAmount,
        //   old_pending_balance : old_balance || 0,
        //   sub_total_due : subTotalDue,
        //   status : status,
        //   remarks : remarks
        // }
        // const invoiceRes = await updateInvoice(params);
        
        
        setListData((prev) =>
          prev.map((item) =>
            item._id === data._id ? { 
              ...item, 

              lottoTotalSales : lottoTotalSalesAmount,
              lottoTotalCommission : lottoTotalCommissionAmount,
              lottoPaidAmount : lottoTotalPaidAmount,


              raffleTotalSales : raffleTotalSalesAmount,
              raffleTotalCommission : raffleTotalCommissionAmount,
              rafflePaidAmount : raffleTotalPaidAmount,

              pointsTotalSales : pointsTotalSalesAmount, 
              pointsTotalCommission : pointsTotalCommissionAmount,
              pointsPaidAmount : pointsTotalPaidAmount,
              pointsIncentives : pointsTotalInsensitiveAmount,
              pointsRedeemCommission   : pointsRedeemCommission,

              total_incentives : pointsTotalInsensitiveAmount,
              total_sales : salesAmount,
              total_commission : commissionAmount,
              total_paid : paidAmount,
              total_due : totalDueAmount,
              old_pending_balance : old_balance || 0,
              sub_total_due : subTotalDue,
              status: status, 
              remarks : remarks } : item
          )
        );
        setPendingInvoiceCount(pendingInvoiceCount - 1);
      }
    }
  } catch (error) {
    console.log("error", error);
    // setIsLoading(false);
  }
};

  return (
    <>
      <div className="container-fluid" ref={targetRef}>
        <TobNavBar title={"Export Invoice"}></TobNavBar>
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}>
           {(ALLLISTDATA?.length > 0 && pendingInvoiceCount > 0) && (
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <div className="inventory_all_tabs">
                <div className="all_tabs_value">
                  <h4>Successfully processed {pendingInvoiceCount} out of the {ALLLISTDATA.length} invoices.</h4>  
                  <blink >Preparing {pendingInvoice[pendingInvoiceCount - 1]?.store} invoice... </blink>
                </div>                  
              </div>
            </Box>                      
           )} 
            <VendorList 
              >
              <div>
                <div id="content-wrapper" className="d-flex flex-column">
                  <div className="card shadow mb-4">
                    <div className="card-body pt-0">
                      <div className="table-responsive">
                        <table
                          className="table table-bordered"
                          id="dataTable"
                          width="100%"
                          cellspacing="0"
                        >
                          <thead>
                            <tr>
                              <th>Sl No.</th>
                              <th>Customer's Details</th>
                              <th>Period</th>
                              <th>Amount</th>
                              <th>Due Date</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {ALLLISTDATA?.length > 0 ? (
                              ALLLISTDATA.map((items, index) => (
                                <>
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td className="admin_user_list_date"> 
                                      <span>Store : {items?.store}</span><br/>
                                      <span>Name : {items?.users_name}</span><br/> 
                                      <span>Mobile : {items?.users_mobile}</span>
                                    </td>
                                    
                                    <td className="admin_user_list_date">
                                      From : 
                                      {`
                                        ${moment(items?.start_date).format("DD-MM-YYYY")} 
                                        ${moment(`2025-03-03 ${items?.start_time}`).format("hh:mm A")}
                                      `} 
                                      <br/>
                                      To : 
                                      {`
                                        ${moment(`${items?.end_date}`).format("DD-MM-YYYY")} 
                                        ${moment(`2025-03-03 ${items?.end_time}`).format("hh:mm A")}
                                      `} 
                                    </td>
                                    <td className="admin_user_list_date">{items?.sub_total_due?items.sub_total_due?.toFixed(2):'-'}</td>
                                    {items?.due_date?(
                                      <td className="admin_user_list_date">
                                        <h6 dangerouslySetInnerHTML={{ __html: getRelativeTime(items?.due_date) }}></h6>
                                        {moment(`${items?.due_date}`).format("DD-MM-YYYY")}
                                      </td>

                                    ):(
                                      <td className="admin_user_list_date">-</td>
                                    )}
                                      
                                    <td className="admin_user_list_date">{items?.status}</td>

                                  </tr>
                                </>
                              ))
                            ) : isLoading ? <SkeltonList row={10} col={7} /> : <tr> 
                                <td colspan="7" className="img-center" >No data found !</td> 
                            </tr>}
                          </tbody>
                        </table>
                        
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VendorList>
          </Box>
        </div>
      </div>
    </>
  );
}
